import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { IDragDropConfiguration } from '@core/interfaces/idrag-drop-configuration';
import { IModalData } from '@core/interfaces/imodal-data';
import { LatestNewsService } from '@core/services/latest-news.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription, take } from 'rxjs';
import { ConfirmCancelComponent } from '../shared/confirm-cancel/confirm-cancel.component';
import { ILatestNews } from '@core/interfaces/ilatest-news';
import { LatestNewsFormComponent } from './latest-news-form/latest-news-form.component';
import { cloneDeep } from 'lodash';
import { faPlusSquare, faTrash, faEdit } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-latest-news-section',
    templateUrl: './latest-news-section.component.html',
    styleUrls: ['./latest-news-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LatestNewsSectionComponent {
  @ViewChild(LatestNewsFormComponent) latestNewsFormComponent!: LatestNewsFormComponent;
  private subscriptions = new Subscription();
  latestNews: ILatestNews[] = [];
  isCollapsed = false;
  latestNewsData: ILatestNews | null = null;

  faPlusSquare = faPlusSquare;
  faTrash = faTrash;
  faEdit = faEdit;

  configuration: IDragDropConfiguration = {
    imageClass: 'large',
    imagePositionClass: 'd-flex justify-content-center',
    editable: true
  }

  constructor(
    private latestNewsService: LatestNewsService,
    private modal: NgbModal
  ) { }

  ngOnInit(): void {
    this.getLatestNews();
  }

  getLatestNews(): void {
    this.latestNewsService.getAll().pipe(
      take(1)
    ).subscribe((res: ILatestNews[]) => this.latestNews = res);
    this.isCollapsed = false;
  }

  addLatestNews(): void {
    this.isCollapsed = !this.isCollapsed;
    this.latestNewsData = null;
    this.resetFormInChild(); 
  }

  resetFormInChild(): void {
    if (this.latestNewsFormComponent) {
      this.latestNewsFormComponent.resetForm();
    }
  }

  edit(latestNews: ILatestNews): void {
    this.latestNewsData = cloneDeep(latestNews);
    this.isCollapsed = true;
  }

  confirmDelete(data: any): void {
    const modalData: IModalData = {
      title: 'Confirm Delete',
      body: '<p>Are you sure you want to delete this latest news?</p>',
      cancelBtnText: 'Cancel',
      confirmBtnText: 'Confirm'
    }
    const modalRef = this.modal.open(ConfirmCancelComponent);
    modalRef.componentInstance.data = modalData;
    modalRef.result
      .then((_res: any) => {
        this.latestNewsService.deleteLatestNews(data.id, "Latest news successfully deleted!").pipe(
          take(1)
        ).subscribe((res: any) => this.getLatestNews());
      })
      .catch((_err: any) => false);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
